<template>
    <v-layout row :class="fullscreen ? 'mt-5' : ''">
        <v-flex :offset-xs0="fullscreen" :xs12="fullscreen" :offset-md3="fullscreen" :md6="fullscreen">
            <v-card class="grey lighten-4 elevation-3">
                <v-card-text>
                    <v-container fluid>
                        <form @submit.prevent.stop="submit">
                            <v-layout column>
                                <v-flex xs12>
                                    <v-btn-toggle v-model="userType" mandatory class="hidden-sm-and-up mb-3">
                                        <v-layout wrap class="text-xs-center">
                                            <v-flex xs12>
                                                <v-btn block value="professor" style="width:100%; min-height: 30px;">
                                                    <span>Professor/Aluno da UNIFEBE</span>
                                                </v-btn>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-btn block value="visitante" style="width:100%; min-height: 30px;">
                                                    <span>Visitante (público externo)</span>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-btn-toggle>
                                    <v-tabs v-model="userType" grow centered>
                                        <v-tabs-bar light class="hidden-xs-only">
                                            <v-tabs-slider color="primary"></v-tabs-slider>
                                            <v-tabs-item href="#professor">
                                                Professor/Aluno da UNIFEBE
                                            </v-tabs-item>
                                            <v-tabs-item href="#visitante">
                                                Visitante (público externo)
                                            </v-tabs-item>
                                        </v-tabs-bar>
                                        <v-tabs-items>
                                            <v-tabs-content id="professor">
                                                <v-card flat>
                                                    <v-card-text>Informe abaixo seu código e senha de acesso da Central Acadêmica.</v-card-text>
                                                </v-card>
                                            </v-tabs-content>
                                            <v-tabs-content id="visitante">
                                                <v-card flat>
                                                    <v-card-text>Informe abaixo seu CPF/Passaporte e sua senha de acesso.<br>
                                                         Ou clique em <strong>Cadastrar-se</strong> caso ainda não tenha cadastro de visitante.</v-card-text>
                                                </v-card>
                                            </v-tabs-content>                                            
                                        </v-tabs-items>
                                    </v-tabs>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field :label="useridLabel" v-model="credentials.userid" data-vv-as="Código" data-vv-name="userid"
                                        prepend-icon="person"
                                        v-validate="'required'" :errors="vErrors.collect('userid')" required></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="Senha" v-model="credentials.password" data-vv-as="Senha" data-vv-name="password"
                                        prepend-icon="security" type="password"
                                        v-validate="'required'" :errors="vErrors.collect('password')" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 class="text-xs-center">
                                    <v-btn type="submit" color="primary" dark large>Entrar</v-btn>
                                    <v-btn type="button" color="info" dark large
                                        to="/ouvinte/cadastrar"
                                        v-if="userType == 'visitante'">Cadastrar-se</v-btn>
                                </v-flex>
                            </v-layout>
                        </form>
                    </v-container>
                    <v-alert :value="true" error v-if="error">{{ error }}</v-alert>
                </v-card-text>
                <v-card-actions v-if="showActions">
                    <slot name="actions"></slot>
                </v-card-actions>                 
            </v-card>
        </v-flex>       
        <fullscreen-spinner></fullscreen-spinner>
    </v-layout>
</template>

<script>
    import auth from '../auth'
    export default {
        props: {
            redirect: {
                default: '/',
                type: [String, Boolean]
            },
            fullscreen: {
                default: true,
                type: Boolean
            },
            userTypeDef: {
                default: '',
                type: String
            }
        },
        data() {
            return {
                userType: 'professor',
                credentials: {
                    userid: '',
                    password: ''
                },
                error: '',
                showActions: false
            }
        },
        computed: {
            useridLabel: function() {
                if (this.userType != 'visitante') return 'Código da Central Acadêmica'
                return 'CPF/Passaporte'
            }
        },
        methods: {
            submit() {
                var credentials = {
                    userid: this.credentials.userid,
                    password: this.credentials.password
                }
                var that = this
                auth.login(this, credentials, this.redirect, function() {
                    if (auth.user.authenticated) {
                        that.$emit('logged-in')
                    }                    
                })
            }
        },
        created() {
            this.showActions = typeof this.$slots['actions'] !== 'undefined'
            if (this.userTypeDef == 'visitante') {
                this.userType = 'visitante'
            }
        }

    }

</script>


// WEBPACK FOOTER //
// Login.vue?35866288